<div class="flex items-center justify-center dialog-header ">
  {{type}} Orgnization Config

  <div class="absolute right-2">
    <button (click)="handleCloseDialog()" class="outline-none p-5">
      <i class="pi pi-times"></i>
    </button>
  </div>

</div>

<div class="dialog-content">
  <form [formGroup]="configForm" (ngSubmit)="submitForm()" class="p-fluid grid grid-cols-2 gap-6">


    <!-- EMAIL CONFIG -->
    <div formGroupName="email_config" class="col-span-2">
      <!-- Top-level controls inside email_config -->
      <h4 class="text-lg mt-4">Email Config</h4>
      <div class="grid grid-cols-2 gap-4">
        <div class="flex flex-col">
          <label>Client Name *</label>
          <input pInputText formControlName="clientName" class="w-full" />
        </div>

        <div class="flex flex-col">
          <label>Support Email *</label>
          <input pInputText formControlName="support_email_id" class="w-full" />
        </div>

        <div class="flex flex-col">
          <label>Speciality Title *</label>
          <input pInputText formControlName="speciality_title" class="w-full" />
        </div>

        <div class="flex flex-col">
          <label>Client Complement *</label>
          <input pInputText formControlName="clientComplement" class="w-full" />
        </div>
      </div>

      <!-- SES Config -->
      <h4 class="text-lg mt-4">SES Config</h4>
      <div formGroupName="ses" class="grid grid-cols-2 gap-4">
        <input pInputText formControlName="host" placeholder="Host" />
        <input pInputText formControlName="port" placeholder="Port" />
        <input pInputText formControlName="user" placeholder="User" />
        <input pInputText formControlName="api_key" placeholder="API Key" />
        <input pInputText formControlName="password" placeholder="Password" />
        <input pInputText formControlName="from_email" placeholder="From Email" />
        <input pInputText formControlName="reply_to_email" placeholder="Reply To Email" />
      </div>

      <!-- Gmail Config -->
      <h4 class="text-lg mt-4">Gmail Config</h4>
      <div formGroupName="gmail" class="grid grid-cols-2 gap-4">
        <input pInputText formControlName="host" placeholder="Host" />
        <input pInputText formControlName="port" placeholder="Port" />
        <div formGroupName="password" class="grid grid-cols-2 gap-4">
          <input pInputText formControlName="iv" placeholder="IV" />
          <input pInputText formControlName="content" placeholder="Content" />
        </div>
        <input pInputText formControlName="from_email" placeholder="From Email" />
      </div>

      <!-- Yahoo Config -->
      <h4 class="text-lg mt-4">Yahoo Config</h4>
      <div formGroupName="yahoo" class="grid grid-cols-2 gap-4">
        <input pInputText formControlName="host" placeholder="Host" />
        <input pInputText formControlName="port" placeholder="Port" />
        <div formGroupName="password" class="grid grid-cols-2 gap-4">
          <input pInputText formControlName="iv" placeholder="IV" />
          <input pInputText formControlName="content" placeholder="Content" />
        </div>
        <input pInputText formControlName="from_email" placeholder="From Email" />
      </div>
    </div>



    <!-- WhatsApp Config -->
    <div formGroupName="whats_app_config" class="col-span-2">
      <h4 class="text-lg mt-4">WhatsApp Config</h4>
      <div class="grid grid-cols-2 gap-4">
        <input pInputText formControlName="email" placeholder="Email" />
        <input pInputText formControlName="app_id" placeholder="App ID" />
        <input pInputText formControlName="source" placeholder="Source" />
        <input pInputText formControlName="api_key" placeholder="API Key" />
        <input pInputText formControlName="app_name" placeholder="App Name" />
        <input pInputText formControlName="password" placeholder="Password" />
        <input pInputText formControlName="app_token" placeholder="App Token" />
      </div>
    </div>

    <!-- Payment Config -->
    <div formGroupName="payment_config" class="col-span-2">
      <h4 class="text-lg mt-4">Payment Config</h4>
      <div class="grid grid-cols-2 gap-4">
        <p-select [options]="gateways" formControlName="gateway" placeholder="Select Gateway"></p-select>
        <input pInputText formControlName="api_key" placeholder="API Key" />
      </div>
    </div>

    <!-- Notification -->
    <div class="flex flex-col">
      <label>Notification Enabled</label>
      <p-toggleswitch formControlName="is_notification_enabled"></p-toggleswitch>
    </div>

    <!-- Charges -->
    <div formGroupName="charges" class="col-span-2 grid grid-cols-2 gap-4">
      <label>Charges</label>
      <input pInputText type="number" formControlName="subscription_fee" placeholder="Subscription Fee" />
      <label>Transaction Fee</label>
      <input pInputText type="number" formControlName="transaction_fee" placeholder="Transaction Fee" />
    </div>

    <!-- Payment Method -->
    <div class="flex flex-col col-span-2">
      <label>Payment Method</label>
      <input pInputText formControlName="payment_method" class="w-full" />
    </div>

    <!-- Submit -->
    <div class="col-span-2 flex justify-end mt-6">
      <p-button label="Submit" icon="pi pi-check" type="submit" [loading]="isLoading"
        [disabled]="configForm.invalid || isLoading"></p-button>
    </div>
  </form>

</div>